import React from "react"
import { Box, TableRow, TableCell, Typography, IconButton } from "@mui/material"
import { ExpandMore, ChevronRight } from "@mui/icons-material"
import type { FactorRuleDisplay, FactorRuleDisplayType, FactorRuleField } from "../types"
import { createRuleKey } from "../helpers"
import FactorRuleRow from "./row"
import { getTableHeaders } from "./table"

interface FactorRulesGroupProps {
  groupKey: string
  groupRules: FactorRuleDisplay[]
  allRules: FactorRuleDisplay[]
  isExpanded: boolean
  ruleDisplayType: FactorRuleDisplayType
  hasBase: boolean
  onToggle: () => void
  handleUpdateRule: (rule: FactorRuleDisplay, field: FactorRuleField, value: string | undefined, ruleDisplayType: FactorRuleDisplayType) => void
  handleRemoveRule: (rule: FactorRuleDisplay, ruleDisplayType: FactorRuleDisplayType) => void
  handleToggleActiveValue?: (rule: FactorRuleDisplay, ruleDisplayType: FactorRuleDisplayType) => void
}

export function FactorRulesGroup({
  groupKey,
  groupRules,
  allRules,
  isExpanded,
  ruleDisplayType,
  hasBase,
  onToggle,
  handleUpdateRule,
  handleRemoveRule,
  handleToggleActiveValue,
}: FactorRulesGroupProps) {
  return (
    <React.Fragment key={groupKey}>
      <TableRow
        className="table-row group-header"
        onClick={onToggle}
      >
        <TableCell
          colSpan={getTableHeaders(ruleDisplayType, hasBase).length}
          className="table-cell group-header-cell"
        >
          <Box className="group-header-content">
            <IconButton size="small" className="group-toggle-button">
              {isExpanded ? <ExpandMore fontSize="small" /> : <ChevronRight fontSize="small" />}
            </IconButton>
            <Typography variant="body2" fontWeight="600">
              {groupKey}
            </Typography>
          </Box>
        </TableCell>
      </TableRow>
      {isExpanded && groupRules.map((rule) => {
        const ruleKey = createRuleKey(rule)
        const originalIndex = allRules.findIndex(r => createRuleKey(r) === ruleKey)
        return (
          <FactorRuleRow
            key={ruleKey}
            rule={rule}
            index={originalIndex}
            ruleDisplayType={ruleDisplayType}
            handleUpdateRule={handleUpdateRule}
            handleRemoveRule={handleRemoveRule}
            handleToggleActiveValue={handleToggleActiveValue}
            hasBase={hasBase}
          />
        )
      })}
    </React.Fragment>
  )
}
